// Exports the "autolink" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autolink')
//   ES2015:
//     import 'tinymce/plugins/autolink'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/autolink/index.js